import Component from '../abstracts/Component';

export default class SelectComponent extends Component {

  get SELECTORS() {
    return {
      main: 'select',
      sizeSelect: 'js-variant-list',
      withInput: '[data-with-input]'
    };
  }

  get BASE_CONF() {
    return {
      minimumResultsForSearch: Infinity,
      maximumSelectionLength: 10,
      width: 'style'
    }
  }

  //bottom value needed to put the input at the bottom of the select options
  get WITH_INPUT_CONF() {
    return {
      maximumSelectionLength: 10,
      tags: true,
      inputPosition: 'bottom'
    }
  }

  constructor() {
    super();
  }

  optionTemplate(opt) {
    // check se ha caricato la select
    if (opt.element) {
      if (opt.element.dataset.msg) {
        var $opt = $(
          '<p>' + opt.element.value + '<span> ' + opt.element.dataset.msg + '</span></p>'
        );
      } else {
        var $opt = $(
          '<p>' + opt.text + '</p>'
        );
      }
    } else {
      var $opt = $(
        '<p>' + opt.text + '</p>'
      );
    }
    return $opt;
  }

  selectedTemplate(opt) {
    if (opt.element) {
      if (opt.element.dataset.msg) {
        var $opt = $(
          '<p><span class="selected-size">' + opt.element.dataset.msgSelected + ' </span>' + opt.element.value + '<span class="custom-msg"> ' + opt.element.dataset.msg + '</span></p>'
        );
      } else {
        var $opt = $(
          '<p><span class="selected-size">' + opt.element.dataset.msgSelected + ' </span>' + opt.text + '</p>'
        );
      }
    } else {
      var $opt = $(
        '<p>' + opt.text + '</p>'
      );
    }
    return $opt;
  }

  initSelect() {
    const elements = document.querySelectorAll(this.SELECTORS.main);
    elements.forEach(el => {
      let data = el.dataset.withInput ? this.WITH_INPUT_CONF : this.BASE_CONF;
      if (el.classList.contains(this.SELECTORS.sizeSelect)) {
        data['templateResult'] = this.optionTemplate;
        data['templateSelection'] = this.selectedTemplate;
        data['language'] = {
          noResults: () => {
            return el.dataset.emptySelect
          }
        };
      }
      $(el).select2(data);
    });

  }

  loadAndInit() {
    this.moduleLoader.loadSelect2(
      (module) => {
        this.initSelect();
      },
      (error) => {
        console.log("failed to load select2 ", error.stack);
      }
    );
  }

  render() {
    this.loadAndInit();
  }
}
